import React from 'react'
import { CircularProgress, Stack } from '@mui/material'
import { com } from '@eidu/web'
import useEntityType from '../../io/useEntityType'
import ManageEntityTypeForm from './ManageEntityTypeForm'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

type ManageEntityTypePageProps = {
  entityTypeId: EntityTypeId | undefined
}

const EditEntityType = ({ entityTypeId }: { entityTypeId: EntityTypeId }) => {
  const { entityType } = useEntityType(entityTypeId)
  if (entityType === undefined) {
    return (
      <Stack padding={3} alignItems="center">
        <CircularProgress />
      </Stack>
    )
  }
  return <ManageEntityTypeForm key={entityTypeId.toString()} entityTypeId={entityTypeId} entityType={entityType} />
}

const ManageEntityTypePage = ({ entityTypeId }: ManageEntityTypePageProps) =>
  entityTypeId ? (
    <EditEntityType entityTypeId={entityTypeId} />
  ) : (
    <ManageEntityTypeForm key="new" entityTypeId={undefined} entityType={null} />
  )

export default ManageEntityTypePage
